"use client";
import { IAccountAssets, IBlocks, IUserData } from "@/types";
import React from "react";
import CardSetting from "@/components/admin/settings/CardSetting";
import { v4 as uuidv4 } from "uuid";
import { Button } from "@/components/ui/button";
import { replaceProtocolWithHTTPS, startsWithHTTPS } from "@/lib/utils";
import * as tabler from "@tabler/icons-react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { Label } from "@/components/ui/label";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";
import ColorPicker from "react-gcolor-picker";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { Switch } from "@/components/ui/switch";
import BlockMetadata from "../metadata";
import IconAssetPicker from "../iconAssetPicker";
import RenderIconOrAsset from "../../../RenderIconOrAsset";
import LinkSelectorDropdown from "../LinkSelectorDropdown";
interface Props {
    account: IUserData;
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
    assets: IAccountAssets[];
}
export default function SocialButtonsOptions({
    account,
    block,
    blockUpdate,
    update,
    assets,
}: Props) {
    const [icons, setIcons] = React.useState<
        {
            id: string;
            icon: string;
            url: string;
            style: {
                enabled: boolean;
                text: string;
                background: string;
            };
        }[]
    >(block.options?.icons || []);
    React.useEffect(() => {
        if (block.options?.icons) {
            setIcons(block.options?.icons);
        }
    }, [block.options?.icons]);
    const [accordionOpen, setAccordionOpen] = React.useState<any>(null);
    const moveIcons = async (index: number, direction: "up" | "down") => {
        const Icons = [...icons];
        const [movedIcon] = Icons.splice(index, 1);
        if (direction === "up") {
            Icons.splice(index - 1, 0, movedIcon);
        } else {
            Icons.splice(index + 1, 0, movedIcon);
        }
        setIcons(Icons);
        update({
            ...block,
            options: {
                ...block.options,
                icons: Icons,
            },
        });
    };
    return (
        <CardSetting title={"Your Links"} noBorder>
            <div className="border-3 flex w-full flex-col gap-3 border-white">
                <Accordion
                    type="single"
                    collapsible
                    value={accordionOpen}
                    onValueChange={setAccordionOpen}
                    className=""
                >
                    <div className="relative flex w-full flex-col gap-4">
                        {icons.map((button: any, index: number) => {
                            const linkSelect = (_url: string) => {
                                setIcons(
                                    icons.map((icon: any) => {
                                        if (icon.id == button.id) {
                                            icon.url = _url;
                                        }
                                        return icon;
                                    })
                                );
                            };
                            return (
                                <div
                                    key={button.id}
                                    className="relative flex items-start gap-2"
                                >
                                    {/* <tabler.IconGripVertical className="handle" /> */}
                                    <div className="flex flex-col gap-0.5">
                                        <Button
                                            variant="ghost"
                                            size="icon"
                                            onClick={() =>
                                                moveIcons(index, "up")
                                            }
                                            disabled={index === 0}
                                        >
                                            <tabler.IconArrowUp />
                                        </Button>
                                        <Button
                                            variant="ghost"
                                            size="icon"
                                            onClick={() =>
                                                moveIcons(index, "down")
                                            }
                                            disabled={
                                                index === icons.length - 1
                                            }
                                        >
                                            <tabler.IconArrowDown />
                                        </Button>
                                    </div>
                                    <AccordionItem
                                        value={button.id}
                                        className="w-full rounded-md border-2 bg-card"
                                    >
                                        <AccordionTrigger className="flex w-full items-center gap-2 rounded-md bg-accent/30 px-2 hover:no-underline data-[state=open]:rounded-b-none">
                                            <div className="flex w-full items-center gap-1">
                                                <RenderIconOrAsset
                                                    account_id={account.id}
                                                    iconName={button.icon}
                                                    size={26}
                                                    raw
                                                />{" "}
                                                <span className="w-72 truncate text-left text-xs">
                                                    {button.url}
                                                </span>
                                            </div>
                                        </AccordionTrigger>
                                        <AccordionContent className="flex flex-col gap-2 rounded-b-md px-2 py-2">
                                            <div className="flex items-end gap-1">
                                                <Input
                                                    variant="card"
                                                    label="URL"
                                                    className=""
                                                    value={button.url}
                                                    onChange={(e) => {
                                                        setIcons(
                                                            icons.map(
                                                                (icon: any) => {
                                                                    if (
                                                                        icon.id ==
                                                                        button.id
                                                                    ) {
                                                                        icon.url =
                                                                            e.target.value;
                                                                    }
                                                                    return icon;
                                                                }
                                                            )
                                                        );
                                                    }}
                                                    onBlur={(e) => {
                                                        if (
                                                            !startsWithHTTPS(
                                                                e.target.value
                                                            )
                                                        ) {
                                                            e.target.value =
                                                                replaceProtocolWithHTTPS(
                                                                    e.target
                                                                        .value
                                                                );
                                                            setIcons(
                                                                icons.map(
                                                                    (
                                                                        icon: any
                                                                    ) => {
                                                                        if (
                                                                            icon.id ==
                                                                            button.id
                                                                        ) {
                                                                            icon.url =
                                                                                e.target.value;
                                                                        }
                                                                        return icon;
                                                                    }
                                                                )
                                                            );
                                                        }
                                                    }}
                                                />
                                                <LinkSelectorDropdown
                                                    account={account}
                                                    linkSelect={linkSelect}
                                                />
                                            </div>
                                            <IconAssetPicker
                                                account={account}
                                                //@ts-expect-error
                                                block={{
                                                    icon: button.icon,
                                                }}
                                                update={(e) => {
                                                    setIcons(
                                                        icons.map(
                                                            (icon: any) => {
                                                                if (
                                                                    icon.id ==
                                                                    button.id
                                                                ) {
                                                                    icon.icon =
                                                                        e.icon;
                                                                }
                                                                return icon;
                                                            }
                                                        )
                                                    );
                                                }}
                                                assets={assets}
                                            />

                                            <div className="flex items-center justify-between">
                                                <div className="flex items-center gap-2">
                                                    <Label variant="toggle">
                                                        NSFW Warning
                                                    </Label>
                                                    <Popover>
                                                        <PopoverTrigger asChild>
                                                            <div className="cursor-pointer rounded-md bg-accent p-1">
                                                                <tabler.IconQuestionMark
                                                                    size={14}
                                                                    className=""
                                                                />
                                                            </div>
                                                        </PopoverTrigger>
                                                        <PopoverContent className="z-[9999] space-y-2 p-1">
                                                            <Label
                                                                variant={
                                                                    "subtoggle"
                                                                }
                                                            >
                                                                Provides context
                                                                if this link
                                                                goes to mature
                                                                and/or NSFW
                                                                content. It will
                                                                prompt a warning
                                                                to the user
                                                                before they
                                                                click on the
                                                                link.
                                                            </Label>
                                                            <Label
                                                                variant={
                                                                    "subtoggle"
                                                                }
                                                            >
                                                                Depending on the
                                                                link provided,
                                                                we may
                                                                automatically
                                                                add this warning
                                                                which cannot be
                                                                removed.
                                                            </Label>
                                                        </PopoverContent>
                                                    </Popover>
                                                </div>
                                                <Switch
                                                    onCheckedChange={(
                                                        checked
                                                    ) =>
                                                        setIcons(
                                                            icons.map(
                                                                (icon: any) => {
                                                                    if (
                                                                        icon.id ==
                                                                        button.id
                                                                    ) {
                                                                        icon.adult =
                                                                            checked;
                                                                    }
                                                                    return icon;
                                                                }
                                                            )
                                                        )
                                                    }
                                                    checked={button.adult}
                                                />
                                            </div>

                                            <div className="flex items-center justify-between">
                                                <Label variant="toggle">
                                                    Custom theme
                                                </Label>
                                                <Switch
                                                    onCheckedChange={(
                                                        checked
                                                    ) =>
                                                        setIcons(
                                                            icons.map(
                                                                (icon: any) => {
                                                                    if (
                                                                        icon.id ==
                                                                        button.id
                                                                    ) {
                                                                        icon.style.enabled =
                                                                            checked;
                                                                    }
                                                                    return icon;
                                                                }
                                                            )
                                                        )
                                                    }
                                                    checked={
                                                        button.style.enabled
                                                    }
                                                />
                                            </div>

                                            {button.style?.enabled && (
                                                <>
                                                    <div className="flex items-center justify-between gap-4">
                                                        <div className="">
                                                            <Label>
                                                                Icon color
                                                            </Label>
                                                        </div>
                                                        <Popover>
                                                            <PopoverTrigger
                                                                asChild
                                                            >
                                                                <Button
                                                                    className="h-9 w-9 rounded-full border-2 border-primary"
                                                                    style={{
                                                                        background:
                                                                            button
                                                                                .style
                                                                                .text,
                                                                    }}
                                                                ></Button>
                                                            </PopoverTrigger>
                                                            <PopoverContent className="z-[999]">
                                                                <ColorPicker
                                                                    showAlpha={
                                                                        false
                                                                    }
                                                                    value={
                                                                        button
                                                                            .style
                                                                            .text
                                                                    }
                                                                    onChange={(
                                                                        color
                                                                    ) => {
                                                                        setIcons(
                                                                            icons.map(
                                                                                (
                                                                                    icon: any
                                                                                ) => {
                                                                                    if (
                                                                                        icon.id ==
                                                                                        button.id
                                                                                    ) {
                                                                                        icon.style.text =
                                                                                            color;
                                                                                    }
                                                                                    return icon;
                                                                                }
                                                                            )
                                                                        );
                                                                    }}
                                                                />
                                                            </PopoverContent>
                                                        </Popover>
                                                    </div>
                                                    <div className="flex items-center justify-between gap-4">
                                                        <div className="">
                                                            <Label>
                                                                Background color
                                                            </Label>
                                                        </div>
                                                        <Popover>
                                                            <PopoverTrigger
                                                                asChild
                                                            >
                                                                <Button
                                                                    className="h-9 w-9 rounded-full border-2 border-primary"
                                                                    style={{
                                                                        background:
                                                                            button
                                                                                .style
                                                                                .background,
                                                                    }}
                                                                ></Button>
                                                            </PopoverTrigger>
                                                            <PopoverContent className="z-[999]">
                                                                <ColorPicker
                                                                    showAlpha={
                                                                        false
                                                                    }
                                                                    gradient
                                                                    value={
                                                                        button
                                                                            .style
                                                                            .background
                                                                    }
                                                                    onChange={(
                                                                        color
                                                                    ) => {
                                                                        setIcons(
                                                                            icons.map(
                                                                                (
                                                                                    icon: any
                                                                                ) => {
                                                                                    if (
                                                                                        icon.id ==
                                                                                        button.id
                                                                                    ) {
                                                                                        icon.style.background =
                                                                                            color;
                                                                                    }
                                                                                    return icon;
                                                                                }
                                                                            )
                                                                        );
                                                                    }}
                                                                />
                                                            </PopoverContent>
                                                        </Popover>
                                                    </div>
                                                </>
                                            )}
                                            <BlockMetadata
                                                //@ts-expect-error
                                                block={{
                                                    metadata: button.metadata,
                                                }}
                                                update={(e) => {
                                                    setIcons(
                                                        icons.map(
                                                            (icon: any) => {
                                                                if (
                                                                    icon.id ==
                                                                    button.id
                                                                ) {
                                                                    icon.metadata =
                                                                        e.metadata;
                                                                }
                                                                return icon;
                                                            }
                                                        )
                                                    );
                                                }}
                                            />
                                            <div className="ml-auto flex items-center gap-3">
                                                <Button
                                                    className="text-error ml-auto w-fit"
                                                    variant="outline"
                                                    size={"icon"}
                                                    onClick={() => {
                                                        setIcons(
                                                            icons.filter(
                                                                (icon: any) =>
                                                                    icon.id !=
                                                                    button.id
                                                            )
                                                        );
                                                        update({
                                                            ...block,
                                                            options: {
                                                                ...block.options,
                                                                icons: icons.filter(
                                                                    (
                                                                        icon: any
                                                                    ) =>
                                                                        icon.id !=
                                                                        button.id
                                                                ),
                                                            },
                                                        });
                                                    }}
                                                >
                                                    <tabler.IconTrash />
                                                </Button>
                                                <Button
                                                    className={`gap-1 ${icons == block.options?.icons ? "hidden" : ""}`}
                                                    onClick={() => {
                                                        setAccordionOpen(null);
                                                        update({
                                                            ...block,
                                                            options: {
                                                                ...block.options,
                                                                icons: icons,
                                                            },
                                                        });
                                                        setIcons(icons);
                                                    }}
                                                >
                                                    <tabler.IconDeviceFloppy
                                                        size={18}
                                                    />
                                                    Save
                                                </Button>
                                            </div>
                                        </AccordionContent>
                                    </AccordionItem>
                                </div>
                            );
                        })}
                    </div>
                </Accordion>
                <div className="flex items-center justify-between gap-2">
                    <Button
                        className="gap-1"
                        onClick={() => {
                            const icon = {
                                id: uuidv4(),
                                url: "",
                                icon: "IconTestPipe",
                                style: {
                                    enabled: false,
                                    text: "",
                                    background: "",
                                },
                            };
                            setIcons([...icons, icon]);
                            update({
                                ...block,
                                options: {
                                    ...block.options,
                                    icons: [...icons, icon],
                                },
                            });
                        }}
                    >
                        <tabler.IconPlus size={18} /> Add
                    </Button>
                </div>
            </div>
        </CardSetting>
    );
}
